import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface FeaturedInsightProps {
  insight: {
    id: string;
    title: string;
    excerpt: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    slug: string;
  };
}

const FeaturedInsight = ({ insight }: FeaturedInsightProps) => {
  return (
    <article className="bg-muted border border-border p-xl mb-2xl">
      <div className="flex items-center space-x-sm mb-md">
        <Icon name="StarIcon" size={16} variant="solid" className="text-primary" />
        <span className="text-xs font-normal tracking-widest text-text-secondary uppercase">
          Featured Analysis
        </span>
      </div>
      
      <h2 className="text-3xl font-light tracking-wide text-primary mb-md leading-tight">
        <Link href={`/insights/${insight.slug}`} className="hover:text-accent transition-colors duration-base">
          {insight.title}
        </Link>
      </h2>
      
      <p className="text-base text-text-secondary mb-lg leading-relaxed max-w-3xl">
        {insight.excerpt}
      </p>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-md">
          <span className="text-xs font-normal tracking-widest text-text-secondary uppercase">
            {insight.category}
          </span>
          <span className="text-xs text-text-secondary">•</span>
          <span className="text-xs text-text-secondary">
            {insight.author}
          </span>
          <span className="text-xs text-text-secondary">•</span>
          <span className="text-xs text-text-secondary">
            {insight.date}
          </span>
          <span className="text-xs text-text-secondary">•</span>
          <span className="text-xs text-text-secondary">
            {insight.readTime}
          </span>
        </div>
        
        <Link 
          href={`/insights/${insight.slug}`}
          className="flex items-center space-x-sm text-sm text-primary hover:text-accent transition-colors duration-base"
        >
          <span>Read Full Analysis</span>
          <Icon name="ArrowRightIcon" size={16} variant="outline" />
        </Link>
      </div>
    </article>
  );
};

export default FeaturedInsight;